const shouldDisplayLogs = true;

export const ConsoleLogs = (TAG, message) => {
  if (shouldDisplayLogs) {
    //  return console.log(`${TAG}, ${message}`);
  }
};
